import { Heading, Link, Stack, Strong, Text } from 'braid-design-system';

import Routes from 'src/config/routes';

const Confirmation = () => (
  <Stack space="medium">
    <Heading level="2" component="h1">
      Thanks, we&apos;ll be in touch shortly
    </Heading>

    <Stack space="medium">
      <Stack space="medium">
        <Text>
          Thanks for your expression of interest in Boosted Ads for your
          business listing.
        </Text>

        <Text>
          A member of our team will be in touch shortly to provide you with
          further information and next steps.
        </Text>
      </Stack>

      <Stack space="small">
        <Text>In the meantime, you can find more information here: </Text>

        <Text>
          <Strong>
            <Link
              href={`https://www.seekbusiness.com.au${Routes.PRIVATE_SELLER_INFO}`}
            >
              {`https://www.seekbusiness.com.au${Routes.PRIVATE_SELLER_INFO}`}
            </Link>
          </Strong>
        </Text>
      </Stack>

      <Stack space="small">
        <Text>Thanks and speak soon,</Text>

        <Text>
          <Strong>The SEEK Business team</Strong>
        </Text>
      </Stack>
    </Stack>
  </Stack>
);

export default Confirmation;
